import { useEffect, useState } from "react";
import Image from "next/legacy/image";
import { CloseButton, Modal } from "react-bootstrap";
import graphic from "../../../public/images/kvrx-hornraiser.webp";
import styles from "./Hornraiser.module.css";

// Turn off after the campaign to remove both the splash and donate styling.
export const HORNRAISER_ACTIVE = true;
const DISMISSED_KEY = "kvrx-hornraiser-2026-dismissed";

export default function Hornraiser() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!HORNRAISER_ACTIVE) return;
    try {
      setShow(!sessionStorage.getItem(DISMISSED_KEY));
    } catch {
      setShow(true);
    }
  }, []);

  const dismiss = () => {
    setShow(false);
    try {
      sessionStorage.setItem(DISMISSED_KEY, "1");
    } catch {
      // The close button still works when browser storage is unavailable.
    }
  };

  return (
    <Modal
      show={show}
      onHide={dismiss}
      centered
      size="lg"
      aria-label="KVRX HornRaiser fundraiser"
    >
      <CloseButton
        className={styles.close}
        variant="white"
        aria-label="Close fundraiser popup"
        onClick={dismiss}
      />
      <a
        href="https://give.utexas.edu/campaigns/87061/donations/new?amt=100"
        target="_blank"
        rel="noopener noreferrer"
        onClick={dismiss}
      >
        <Image
          src={graphic}
          layout="responsive"
          unoptimized
          alt="HornRaiser: help KVRX reach our $5,000 goal this November. Donate for new equipment, cameras, Local Live sets, and our mutual aid pantry."
        />
      </a>
    </Modal>
  );
}
